module.exports = {"371203001":"艾山街道","371203002":"里辛街道","371203003":"汶源街道","371203100":"颜庄镇","371203103":"辛庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371203.json
// module id = 1456
// module chunks = 0